import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';
import SingleTraceView from '../singleTraceView/SingleTraceView';

interface Props {
  snapshotId: number;
  setSnapshotId: Dispatch<SetStateAction<number>>;
  analyzerId: number;
  traceMode: number;
  open: boolean;
  handleClose: () => void;
}

const SingleTraceViewDialog = ({
  snapshotId,
  setSnapshotId,
  analyzerId,
  traceMode,
  open,
  handleClose,
}: Props) => {
  return (
    <Dialog fullWidth maxWidth='xl' open={open}>
      <DialogContent>
        <SingleTraceView
          selectedAnalyzerId={analyzerId}
          selectedSnapshotId={snapshotId}
          setSelectedSnapshotId={setSnapshotId}
          traceMode={traceMode}
          inDialog
          handleDialogClose={handleClose}
        />
      </DialogContent>
      <DialogActions style={{ paddingTop: 0 }}>
        <Button onClick={handleClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default SingleTraceViewDialog;
